import React from 'react';

interface ReviewCardProps {
  name: string;
  review: string;
}

const ReviewCard: React.FC<ReviewCardProps> = ({ name, review }) => {
  return (
    <div className="bg-black p-8 rounded-lg border-2 border-gold flex flex-col h-full">
      <h3 className="text-gold text-xl font-bold mb-4">{name}</h3>
      <p className="text-white flex-grow">{review}</p>
    </div>
  );
};

export default ReviewCard;